import styled from '@emotion/styled';

export const MainBlock = styled.div`
  box-sizing: border-box;
  margin: 24px 24px 0 24px;
  height: calc(100% - 24px);
  display: grid;
  grid-template-rows: auto 1fr;
`;
